import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentController.php
* @route '/api/partners/fetch-fragment/{dossier}'
*/
const FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f.url(args, options),
    method: 'post',
})

FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f.definition = {
    methods: ["post"],
    url: '/api/partners/fetch-fragment/{dossier}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentController.php
* @route '/api/partners/fetch-fragment/{dossier}'
*/
FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentController.php
* @route '/api/partners/fetch-fragment/{dossier}'
*/
FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentController.php
* @route '/api/dossier/{dossier}/fragment'
*/
const FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.url(args, options),
    method: 'get',
})

FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/fragment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentController.php
* @route '/api/dossier/{dossier}/fragment'
*/
FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentController.php
* @route '/api/dossier/{dossier}/fragment'
*/
FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierFragmentController.php
* @route '/api/dossier/{dossier}/fragment'
*/
FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\Partners\FetchDossierFragmentController::FetchDossierFragmentController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchDossierFragmentController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchDossierFragmentController = {
    '/api/partners/fetch-fragment/{dossier}': FetchDossierFragmentController6742393bc1c8a7df7869257be6861f1f,
    '/api/dossier/{dossier}/fragment': FetchDossierFragmentController3e4faf07bc728dc41e2d8121703bddea,
}

export default FetchDossierFragmentController